import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface IUpdateBlogDesignParams {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (val: string) => void;
}

interface IUpdateBlogDesignRequest {
	id: string;
	style: Api.FooterCustomization | Api.HeaderCustomization | Api.BlogHomeCustomization | Api.BlogPostCustomization;
	impersonationContext?: Api.IImpersonationContext;
}

export function useUpdateBlogStyleMutation({ onError, onSuccess }: IUpdateBlogDesignParams = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id, style, impersonationContext }: IUpdateBlogDesignRequest) => {
			if ('links' in style) {
				style.links = removeEmptyLinkObjects(style.links);
				if (style.links.length === 0) {
					delete style.links;
				}
			}

			return userSession.webServiceHelper.callAsync<string>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `CustomPageStyle/${id}/style`,
				}),
				'PUT',
				style
			);
		},
		onError,
		onSuccess,
	});
}

const removeEmptyLinkObjects = (linkObjects: Api.NavLink[]) => {
	const links = [...linkObjects];
	links?.forEach((link, index) => {
		if (!link.label || !link.destination) {
			delete links[index];
		}
	});

	return links.filter(value => value);
};
